module.exports = __webpack_public_path__ + "img/6.053723fa.jpg";